module.exports = __webpack_public_path__ + "static/water-mask-96efa1cfb1934a29d261dc5861e8b001.png";